module.exports = __webpack_public_path__ + "img/goutong.dcb12a94.jpg";